import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './AppWrapper';

ReactDOM.render(
  <AppWrapper />,
  document.getElementById('root')
);

